import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { BaseModal, IModalInstance, ModalHeader } from "@whatslly/ui-components/modals";
import styles from "./AssignPhoneToUserModal.module.scss";
import { ModalButtons } from "@whatslly/ui-components/ModalButtons";
import { AsyncSelect } from "@whatslly/ui-components/v2/BaseElements/Select";
import { useDependencyInjector } from "@whatslly/commons/di";
import { observer } from "mobx-react-lite";
import type { IOrganizationStore } from "../../../services/IOrganizationStore";
import { InjectOrganizationStore } from "../../../services/IOrganizationStore";
import type { SFUserSchema } from "@whatslly/types/analytics/AnalyticsSFTypes";
const getUserOptionLabel = (users: (SFUserSchema & { _id: string })[], _id: string) => {
  const user = users.find((user) => user._id === _id);
  const name = user?.name ?? _id;

  return `${name}${user?.email ? ` (${user.email})` : ""}`;
};

export const AssignPhoneToUserModal: React.FC<IModalInstance<{ selectedUserIds: string[] }> & { initUserIds: string[] }> = observer(
  ({ closeModal, initUserIds }) => {
    const [selectedUserIds, setSelectedUserIds] = useState<string[]>(initUserIds);
    const organizationStore = useDependencyInjector<IOrganizationStore>(InjectOrganizationStore);
    const { t } = useTranslation();
    return (
      <BaseModal
        header={
          <ModalHeader closeModal={() => closeModal()}>{t("whatsapp_business_api_settings_page.actions_phone_table.assign_users")}</ModalHeader>
        }
        closeOnClickOutside={false}
        closeOnEscape={false}
        closeModal={() => closeModal()}
        className={styles.modal}
      >
        <AsyncSelect
          loadOptionsFromServerFunction={async (inputValue) => {
            const users = await organizationStore.usersList;
            const options = users
              .filter((user) => user.isActive && user.name?.toLowerCase().includes(inputValue.toLowerCase()))
              .map((user) => ({ label: `${user.name || user.userId}${user.email ? ` (${user.email})` : ""}`, value: user._id }));
            return { options };
          }}
          data-testid="select_user_to_phone_dropdown"
          isSearchable={false}
          isMulti={true}
          value={organizationStore.usersList.case({
            fulfilled: (users) =>
              selectedUserIds.map((_id) => ({
                label: getUserOptionLabel(users, _id),
                value: _id,
              })),
            pending: () => [],
            rejected: () => [],
          })}
          onChange={(val: { label: string; value: string }[]) => setSelectedUserIds(val.map((v) => v.value))}
        />
        <ModalButtons testId="modal-buttons-submit-button" onCancel={() => closeModal(undefined)} onSubmit={() => closeModal({ selectedUserIds })} />
      </BaseModal>
    );
  }
);
